import React, { memo } from 'react';
import styles from './loadsCard.module.scss';
import plannerViewStyles from '../plannerView.module.scss';
import { GenerateIcon } from '../../../general_components/content_management/task_list/taskListElements/singleAction';
import { addressExtractor } from '../../../general_components/content_management/task_list/taskListElements/listView';
import { TypeToTitle } from '../../../general_components/content_management/task_list/taskListElements/listOfActions';
import { sendRequest, API_ROOT } from '../../../supplementary_components/requests';
import { addNotification } from '../../../supplementary_components/store';
import { DAY_WIDTH_IN_PIXELS } from '../plannerViewTeamCard';
import { offsetToDuration } from './loadObject';

export const positionPopup = (event, ref) => {
    // Always use LEFT/TOP so horizontal scroll code (which adjusts left) works for every case
    ref.style.right = "";
    ref.style.bottom = "";

    const margin = 8;

    // Click position in viewport
    const xClient = event.clientX;
    const yClient = event.clientY;

    // Ensure it's measurable (CSS has display:none by default)
    ref.style.display = "block";

    // Convert to document coords (since popup is position:absolute)
    const scrollX = window.scrollX || window.pageXOffset || 0;
    const scrollY = window.scrollY || window.pageYOffset || 0;

    // Place near click so we can measure the popup
    ref.style.left = `${scrollX + xClient}px`;
    ref.style.top = `${scrollY + yClient}px`;

    const popupRect = ref.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    // "right/bottom"-like behavior near edges:
    // - if there isn't enough room to the right, open to the left of the click
    // - if there isn't enough room below, open above the click
    // Then clamp inside viewport margins.
    let leftClient = xClient;
    let topClient = yClient;

    if (leftClient + popupRect.width + margin > windowWidth) leftClient = xClient - popupRect.width;
    if (topClient + popupRect.height + margin > windowHeight) topClient = yClient - popupRect.height;

    leftClient = Math.min(Math.max(leftClient, margin), Math.max(margin, windowWidth - popupRect.width - margin));
    topClient = Math.min(Math.max(topClient, margin), Math.max(margin, windowHeight - popupRect.height - margin));

    ref.style.left = `${scrollX + leftClient}px`;
    ref.style.top = `${scrollY + topClient}px`;
}

export const openPopup = (event, ref, loadView) => {
    let tagRef = null;
    if(loadView){   
        ref.getElementsByClassName("taskView")[0].style.display = "none";
        tagRef = ref.getElementsByClassName("loadView")[0];
        tagRef.style.display = "";
    }else{
        ref.getElementsByClassName("loadView")[0].style.display = "none";
        tagRef = ref.getElementsByClassName("taskView")[0]
        tagRef.style.display = "";
    }

    // Ensure it's measurable (CSS has display:none by default)
    ref.style.display = "block";

    return tagRef;
}
function handlingTaskClick(e, data, overflowContainer, popupViewManagingObject, open, setOpen, truckId){
    e.stopPropagation();
    if(overflowContainer && overflowContainer.current){
        if(!open){
            const current = overflowContainer.current;
            const taskView = openPopup(e, current, false);
            
            popupViewManagingObject(data.id, overflowContainer, setOpen);

            const address = addressExtractor(data.address);
            const addressBlock = current.querySelector("#addressBlock");
            if(address){
                addressBlock.style.display = "";
                addressBlock.childNodes[1].innerText = `${address.companyName ? address.companyName + "\n" : ""}${address.addressLine1 ? address.addressLine1 + "\n" : ""}${address.city ? address.city : ""}${address.state ?  ', '+address.state : ""}${address.postalCode ? " "+address.postalCode + "\n" : ""}`
            }else{
                addressBlock.style.display = "none";
            }
            const dateTime = data.apptDate || data.apptTime ? `${data.apptDate ? data.apptDate +" ": ""}${data.apptTime || ""}` : null;
            const timeBlock = current.querySelector("#timeBlock");
            if(dateTime){
                timeBlock.style.display = "";
                timeBlock.childNodes[1].innerText = dateTime;
            }else{
                timeBlock.style.display = "none";
            }
            const tasksArray = taskView.querySelectorAll(":scope > div");
            if(data.type === "homeTime" || data.type === "reset"){
                data.actions = [{desc: data.desc, type: data.type, status : data.dispatched ? "Dispatched" : "NotDispatched", actionIndex: data.actionIndex}];
            }
            const actionsLastIndex = data.actions.length - 1; 
            for(let i = 0; i < tasksArray.length; i++){
                const taskBlock = tasksArray[i]; 
                if(i >= data.actions.length ){
                    taskBlock.remove();
                }else{
                    const action = data.actions[actionsLastIndex - i];
                    taskBlockConfigurator(setOpen, data, truckId, actionsLastIndex === i, action, taskBlock, address || dateTime || i !== 0);
                    if(i === tasksArray.length-1 && i + 1 < data.actions.length){
                        for(let k = i + 1; k < data.actions.length; k++){
                            const copy = taskBlock.cloneNode(true); // deep copy
                            const nextAction = data.actions[actionsLastIndex - k];
                            taskBlockConfigurator(setOpen, data, truckId, actionsLastIndex === k, nextAction, copy, true);
                            taskView.appendChild(copy);
                        }
                    }
                }
            }
            // Position after the popup content is populated (avoids extra reflow + RAF pass)
            positionPopup(e, current);
            setOpen(!open);
        }
    }
}
export const TaskCard = memo(({data, overflowContainer, popupViewManagingObject, open, setOpen, truckId})=>{
    // if(data.id === "e5037092-c174-48fd-b301-59a3095f1a76"){
    //     console.log(data.startOffset)
        
    //     if(data.startOffset < 0){
    //         data.width = data.width - data.startOffset;
    //     }
    //     console.log(data.width)
    // }
    if(data.type === "homeTime" || data.type === "reset"){
        let indicatorWidth = null; 
        if(data.warningIndicatorStartOffset){
            indicatorWidth = data.startOffset - data.warningIndicatorStartOffset;
        }
        // if(data.startOffset < 0){
        //     data.width = data.width - data.startOffset;
        //     data.startOffset = -15;
        // }
        // if(data.startOffset + data.width > DAY_WIDTH_IN_PIXELS*9){
        //     data.width = (DAY_WIDTH_IN_PIXELS*9) - data.startOffset +  35;
        // }
        
        return <>
            {data.warningIndicatorStartOffset ? 
            <span className={`${styles.homeTimeWarningIndicator}`} style={{left:data.warningIndicatorStartOffset+"px", width: indicatorWidth+"px", maxWidth:(DAY_WIDTH_IN_PIXELS*5)+"px"}} >
                {formatDuration(offsetToDuration(indicatorWidth))} {data && data.address && data.address.state ? ` (${data.address.state})` : ""}
            </span>
            :null}
            
            <div
                className={`${styles.homeTimeBlock} ${data.dispatched ? styles.dispatched :""}`}
                style={{left:data.startOffset+"px", width: data.width+"px", maxWidth: data.width+"px"}} onClick={(e)=>{handlingTaskClick(e, data, overflowContainer, popupViewManagingObject, open, setOpen, truckId)}} >
                {data.type === "homeTime" ? `Home Time` : "Reset"}
            </div>
    
        </>
    }else{
        let hasUndispatchedActions = false;
        let firstActionType = data.actions[0].type;    
        let status = !data.currentTask && firstActionType  === "custom" && data.actions[0].status === 'Onsite' ? "Dispatched" : data.actions[0].status;
        if(status === "Onsite" && (firstActionType  === "custom")){
            status = "PurpleTask";
        }
        if(status !== "NotDispatched"){
            hasUndispatchedActions = data.hasUndispatchedAction;
        }
        return <div id={data.id} className={`${styles.card} ${styles.taskCard} ${styles[`load${status}`]}`} style={{position:"absolute", left:data.startOffset+"px"}} onClick={(e)=>{handlingTaskClick(e, data, overflowContainer, popupViewManagingObject, open, setOpen, truckId)}} >
            <div>
                {hasUndispatchedActions ? <span className={styles.hasUndispatchedAction}></span> : null}
                {data.actions.length > 1 ?
                    data.actions.length+`X`
                    :
                    GenerateIcon(`thick_`+data.actions[0].type)
                }
                
            </div>
        </div>
    }
})
function showHideLoadingIcon(btnRef, show){
    try {
        btnRef.querySelector("svg").style.opacity = show ? "1.0" :  "0.0";
    } catch (error) {}
}
function taskBlockConfigurator(setOpen, task, truckId, firstAction, actionData, blockTag, hasTopline){
    if(hasTopline){
        if(!blockTag.className.includes(plannerViewStyles.withTopLine)){
            blockTag.className += ` ${plannerViewStyles.withTopLine}`;
        }
    }else{
        blockTag.className = blockTag.className.replace(plannerViewStyles.withTopLine, "");
    }
    blockTag.getElementsByClassName("tskLbl")[0].innerHTML=TypeToTitle(actionData.type) + (actionData.status === "NotDispatched" ? ` <span class="${plannerViewStyles.alert}">(Not Dispatched)</span>` : "");
    const descBLock = blockTag.getElementsByClassName("tskDsc")[0];
    if(actionData.desc){
        descBLock.style.display = "";
        descBLock.innerText=actionData.desc;
    }else{
        descBLock.style.display = "none";
    }
    
    const btn = blockTag.getElementsByClassName("btn")[0];
    const newBtn = btn.cloneNode(true);
    showHideLoadingIcon(newBtn, false);
    btn.parentNode.replaceChild(newBtn, btn);
    if((task.currentTask &&  firstAction && actionData.status !== "Completed") || actionData.status === "NotDispatched"){
        newBtn.style.display = "";
        let btnObj = {stage: 1, msg: "Mark As Dispatched"}; 
        if(actionData.status === "Onsite" || (actionData.status === "Dispatched" && (actionData.type === "park" || task.type === "reset" || task.type === "homeTime"))){
            btnObj = {stage: 3, msg: "Mark As Completed"};
        }else if(actionData.status === "Dispatched"){
            btnObj = {stage: 2, msg: "Mark As Onsite"};
        }
        newBtn.querySelector("span").innerText = btnObj.msg;
        newBtn.onclick = ()=>{
            showHideLoadingIcon(newBtn, true);
            sendRequest('PATCH', `${API_ROOT}trucks/taskToNextStage/${truckId}`, null, (response)=>{
                setOpen(false);
            }, ()=>{
                showHideLoadingIcon(newBtn, false);
                addNotification({message:`Something went wrong`, type:'alert'});
            }, {
                taskId: task.id,
                actionIndex: actionData.actionIndex,
                nextStageIndex: btnObj.stage
            });
        }
    }else{
        newBtn.style.display = "none";
    }
    
    
}

function formatDuration(minutes) {
	const days = Math.floor(minutes / (24 * 60));
	const hours = Math.floor((minutes % (24 * 60)) / 60);
	
	let result = [];
	if (days > 0) result.push(`${days}d`);
	if (hours > 0) result.push(`${hours}h`);
	
	return result.join(' ') || '0h';
}